import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbButtonIcon as ClbButtonIcon_ } from '@celebration/design-system/dist/lib/button-icon';
const events = {
    onClbClick: ClbButtonIcon_.events
        .onClbClick,
};
export const ClbButtonIcon = createComponent({
    tagName: ClbButtonIcon_.tagName,
    elementClass: ClbButtonIcon_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map